import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { WMAIApiService, AppInformationService } from '../core';
import { TranslateService } from '@ngx-translate/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { WgisService } from '../wgis/wgis.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
})
export class ContactComponent implements OnInit {

  contactForm: FormGroup;
  name: string;
  mail: string;
  phone: string;
  object: string;
  message: string;
  consenso: boolean;

  contactMail: string;

  showForm: boolean = true;
  isSmallScreen: boolean;

  subscriptions: Subscription;

  connectionStatusMessage: string;
  connectionStatus: boolean;

  mobile = false;
  /**
   * @param  {string} captchaResponse
   */
  resolved(captchaResponse: string) {
    // console.log(`Resolved captcha with response: ${captchaResponse}`);
  }

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private breakpointObserver: BreakpointObserver,
    private wmaiservice: WMAIApiService,
    private wgisservice: WgisService,
    private appService: AppInformationService
  ) { 
    
    this.wgisservice.setMapInvisible();
    this.isSmallScreen = breakpointObserver.isMatched('(max-width: 768px)');
    this.connectionStatus = appService.getCurrentConnectionStatus();
    this.mobile = this.appService.iAmMobile();
  }

  ngOnInit() {
    this.subscriptions = this.appService.onlineStatus.subscribe(data => {
      this.connectionStatus = data;
    });
    if(this.connectionStatus){
      const nameCtrl = new FormControl(this.name, [Validators.required, Validators.maxLength(50)]);
      const mailCtrl = new FormControl(this.mail, [Validators.required, Validators.maxLength(50)]);
      const phoneCtrl = new FormControl(this.phone, [Validators.required, Validators.maxLength(15)]);
      const objectCtrl = new FormControl(this.object, [Validators.maxLength(50)]);
      const messageCtrl = new FormControl(this.message, [Validators.maxLength(500)]);
      const consensoCtrl = new FormControl(this.consenso, [Validators.required]);

      this.contactForm = this.formBuilder.group({
        name: new FormControl(nameCtrl),
        mail: new FormControl(mailCtrl),
        phone: new FormControl(phoneCtrl),
        object: new FormControl(objectCtrl),
        message: new FormControl(messageCtrl),
        consenso: new FormControl(consensoCtrl)
      });

      this.contactForm.reset();
      this.getMail();
    }
  }

  ngOnDestroy(){
    this.subscriptions.unsubscribe();
  }
  /**
   * nessun tipo di parametro, ritorna la mail richiesta
   */
  getMail() {
      this.wmaiservice.wordsByKey('smtpto').subscribe(data => {
        this.contactMail = data[0].val;
      });
  }

   /**
   * nessun tipo di parametro, invia il contatto
   */
  sendContact(){
    // console.log(this.contactForm.value);
    this.showForm = !this.showForm;
  }

   /**
   * nessun tipo di parametro, invia il contatto tramite il form
   */
  showContactForm(){
    this.showForm = !this.showForm;
  }

}
